module.exports = __webpack_public_path__ + "static/media/page4_bg.a93fb6e0.jpg";